/**
 * A chave de expansão é a posição do item na árvore (`"2"`, `"2-1"`,
 * `"2-1-0"`), então a hierarquia está embutida na própria chave: os
 * ancestrais de `"2-1-0"` são `"2"` e `"2-1"`.
 */
function getAncestorKeys(groupKey: string): string[] {
  const segments = groupKey.split('-');
  return segments.slice(0, -1).map((_, index) => segments.slice(0, index + 1).join('-'));
}

function isDescendantKey(candidate: string, groupKey: string): boolean {
  return candidate.startsWith(`${groupKey}-`);
}

/**
 * Accordion: abrir um menu deixa expandida apenas a cadeia dele, fechando
 * qualquer outro ramo aberto — espelha o comportamento do sidebar legado, em
 * que clicar num menu colapsa os irmãos. Fechar um menu também colapsa os
 * submenus que ele continha, para que não reapareçam abertos na próxima
 * expansão do pai.
 */
export function toggleExpandedPath(current: ReadonlySet<string>, groupKey: string): Set<string> {
  if (current.has(groupKey)) {
    return new Set(
      Array.from(current).filter((key) => key !== groupKey && !isDescendantKey(key, groupKey)),
    );
  }

  return new Set([...getAncestorKeys(groupKey), groupKey]);
}
